import React from 'react';
import { injectIntl } from 'react-intl';
import { InfoBox, Box } from '@landtrustinc/design-system';
import useWhatsIncluded from '../../hooks/useWhatsIncluded';
import useLodgingFeatures from '../../hooks/useLodgingFeatures';

const SectionWhatsIncluded = ({
  currentPackage,
  activityData,
  intl,
  campsites,
  lodging,
  lodgingPricesOptions,
}) => {
  const { features: activityFeatures } = useWhatsIncluded({ currentPackage, activityData, intl });
  const { features: lodgingFeatures } = useLodgingFeatures({
    campsites,
    lodging,
    lodgingPricesOptions,
    intl,
    filterBy: 'required',
  });

  // Combine activity features and lodging features
  const allFeatures = [...activityFeatures, ...lodgingFeatures];

  if (!allFeatures || allFeatures.length === 0) {
    return null;
  }

  return (
    <Box mb="var(--spacing-5)">
      <InfoBox
        heading={intl.formatMessage({ id: 'ListingPage.whatsIncludedTitle' })}
        features={allFeatures}
      />
    </Box>
  );
};

export default injectIntl(SectionWhatsIncluded);
